import { render, staticRenderFns } from "./QuestionTwoContainer.vue?vue&type=template&id=6c4001a6&"
import script from "./QuestionTwoContainer.vue?vue&type=script&lang=js&"
export * from "./QuestionTwoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports